// Functions for searching, filtering, and sorting on video library pages.
//
// Functions that will be called by HTMX are declared on the global window scope.

function resetResultsPage() {
  document.querySelector("input[name='page']").value = 1;
}

window.closeTriggerModals = function (openingModal = false) {
  document.querySelector("#trigger-modal-overlay").classList.add("hidden");

  document
    .querySelectorAll("#trigger-modals .menu--filters")
    .forEach((node) => node.classList.add("hidden"));

  categoryButtons = document.querySelectorAll("#categories .control--filter")
  categoryButtons.forEach((categoryButton) => {
    categoryButton.classList.remove("control--filter--open");
  });

  if (openingModal) {
    // Abort any in-flight search so its response can't swap the filter DOM out
    // from under the dropdown being opened, which would otherwise leave the
    // dimming overlay stuck on with no dropdown visible.
    abortContentFilterRequest();
    return;
  }

  // Re-issue the search only when the form no longer matches what is actually
  // loaded on the page. This skips a redundant search when a dropdown is opened
  // and closed without changes (and the results are already in sync), while
  // still re-issuing when a previous request was aborted before its results
  // loaded so the displayed results catch up with the selected filters.
  if (getContentFilterFormState() === window.contentFilterAppliedState) {
    return;
  }

  resetResultsPage();

  // Abort any in-flight request before submitting so a stale response can't
  // overwrite the results after this newer submission has settled.
  abortContentFilterRequest();
  htmx.trigger(document.querySelector("#content-filter-form"), "submit");
}

window.selectContentType = function (contentType, contentTypeText) {
  const contentTypes = JSON.parse(document.querySelector("#content_type_options").dataset.contentTypes);
  document.querySelector("#content_type_menu_button img").src = contentTypes[contentType];
  document.querySelector("#content_type_menu_button img").alt = contentTypeText;
  document.querySelector("#selected-content-type").textContent = contentTypeText;
  document.querySelector("#content_type_options").classList.add("hidden");

  url =
    window.location.pathname +
    `?content_type=${contentType}` +
    `&sort_order=${
      document.querySelector("#content-filter-form input[name='sort_order']")
        .value
    }` +
    `&display_mode=${
      document.querySelector("#content-filter-form input[name='display_mode']")
        .value
    }` +
    `&query=${
      document.querySelector("#content-filter-form input[name='query']").value
    }` +
    `&general_favorites=${
      document.querySelector("#content-filter-form input[name=general_favorites]").value
    }` +
    `&client_favorites=${
      document.querySelector("#content-filter-form input[name=client_favorites]").value
    }`;

  window.location.href = url;
}

window.positionHierarchyFavoritesPopover = function (event) {
  const popover = event.currentTarget;
  const button = document.querySelector("#favorites-filter");
  if (!button) return;

  if (event.newState === "closed") {
    button.setAttribute("aria-expanded", "false");
    return;
  }

  button.setAttribute("aria-expanded", "true");
  requestAnimationFrame(function () {
    const gap = 8;
    const edge = 8;
    const buttonRect = button.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    let left = buttonRect.left;
    let top = buttonRect.bottom + gap;

    if (top + popoverRect.height > window.innerHeight - edge) {
      top = buttonRect.top - popoverRect.height - gap;
    }

    left = Math.min(left, window.innerWidth - popoverRect.width - edge);
    popover.style.inset = "auto";
    popover.style.left = `${Math.max(edge, left)}px`;
    popover.style.top = `${Math.max(edge, top)}px`;
  });
}

window.toggleHierarchyFavoriteScope = function (checkbox) {
  const form = document.querySelector("#content-filter-form");
  const input = form.querySelector(`input[name="${checkbox.dataset.filterName}"]`);
  input.value = checkbox.checked.toString();

  const generalActive = form.querySelector("input[name=general_favorites]").value === "true";
  const clientActive = form.querySelector("input[name=client_favorites]").value === "true";
  const active = generalActive || clientActive;
  resetResultsPage();
  htmx.trigger(form, "submit");

  const button = document.querySelector("#favorites-filter");
  button.setAttribute("aria-pressed", active.toString());
  button.classList.toggle("button--favorites-filter--active", active);
}

window.toggleFavoritesFilter = function () {
  const input = document.querySelector("#content-filter-form input[name='general_favorites']");
  const active = input.value !== "true";
  input.value = active.toString();
  resetResultsPage();
  htmx.trigger(document.querySelector("#content-filter-form"), "submit");

  const button = document.querySelector("#favorites-filter");
  button.setAttribute("aria-pressed", active.toString());
  button.classList.toggle("button--favorites-filter--active", active);
}

window.selectDisplayMode = function (displayMode) {
  document.querySelector(
    "#content-filter-form input[name='display_mode']"
  ).value = displayMode;

  htmx.trigger(document.querySelector("#content-filter-form"), "submit");

  document.querySelector("#button-grid-view").classList.toggle("selected", displayMode == "grid")
  document.querySelector("#button-list-view").classList.toggle("selected", displayMode !== "grid")
}

window.setSearchQuery = function (search_input) {
  document
    .querySelectorAll("#content-filter-form input[name='query']")
    .forEach((element) => {
      element.value = document.querySelector("#video_query").value;
    });

  document.querySelectorAll("#content-filter-form").forEach((element) => {
    resetResultsPage();
    htmx.trigger(element, "submit");
  });
}

window.setSortOrder = function () {
  document
    .querySelectorAll("#content-filter-form input[name='sort_order']")
    .forEach((element) => {
      element.value = document.querySelector(
        "#video_hierarchy_sort_order"
      ).value;
    });

  document.querySelectorAll("#content-filter-form").forEach((element) => {
    htmx.trigger(element, "submit");
  });
}

window.toggleHierarchyVisibility = function () {
  document.getElementById("hierarchy-container").classList.toggle("hidden");
}

window.toggleModal = function (categoryId) {
  modal = document.querySelector(`#category-${categoryId}-triggers`);
  triggerModalOverlay = document.querySelector("#trigger-modal-overlay");
  categoryButton = document.querySelector(`#category-${categoryId}-button`);

  if (modal.classList.contains("hidden")) {
    window.closeTriggerModals(true);

    let closeButton = modal.querySelector('.button--modal-close');
    if (!closeButton) {
      // Create a wrapper for the existing modal content to make it scrollable
      const contentWrapper = document.createElement('div');
      contentWrapper.classList.add('content-wrapper');

      while (modal.firstChild) {
          contentWrapper.appendChild(modal.firstChild);
      }

      modal.appendChild(contentWrapper);

      closeButton = document.createElement('button');
      // Without an explicit type, a button inside the form defaults to
      // type="submit", so clicking "Done" natively submits the form on top of
      // the submit we trigger from JS. That second (queued) request is then
      // released when the first is aborted, defeating the abort.
      closeButton.type = 'button';
      closeButton.classList.add('button', 'button--modal-close');
      closeButton.innerHTML = 'Done';
      modal.appendChild(closeButton);
    }

    closeButton.addEventListener('click', function() {
      window.closeTriggerModals();
    });

    // Position modal below button, extending to the left by default, or to the right if going left would put us off the page
    const buttonBoundingRectanlge = categoryButton.getBoundingClientRect()
    modal.style.top = `${
      Math.round(buttonBoundingRectanlge.bottom) + window.scrollY
    }px`;
    buttonLeft = Math.round(buttonBoundingRectanlge.left);

    const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const menuWidthInRem = 17.5; /* We can't reliably get the menu width from the DOM at this point, so we duplicate the value fixed in menus.css */

    const fitsOnPage = (buttonLeft + menuWidthInRem * remInPx) < window.innerWidth;
    if (fitsOnPage) {
      modal.style.left = `${buttonLeft}px`;
    } else {
      modal.style.right = `${Math.round(window.innerWidth - buttonBoundingRectanlge.right)}px`;
    }

    categoryButton.classList.add("control--filter--open");
    modal.classList.remove("hidden");
    triggerModalOverlay.classList.remove("hidden");
  } else {
    window.closeTriggerModals();
    categoryButton.classList.remove("control--filter--open");
    triggerModalOverlay.classList.add("hidden");
  }
}

window.onToggleTag = function (categoryId, tagId, selectAll = false) {
  const tagContainer = document.querySelector(`#tag-${tagId}-container`);
  const tagToggle = document.querySelector(`#tag-${tagId}-toggle`);
  const contentFilterForm = document.querySelector("#content-filter-form");

  if (tagToggle.checked) {
    // add hidden input for the newly selected individual tags selected normally and not with "select all"
    let newlyAddedTagsInput = document.querySelector(`input[name="newly_added_tags[]"][value="${tagId}"]`);
    if (!newlyAddedTagsInput && !selectAll) {
        newlyAddedTagsInput = document.createElement("input");
        newlyAddedTagsInput.type = "hidden";
        newlyAddedTagsInput.name = "newly_added_tags[]";
        newlyAddedTagsInput.value = tagId;
        contentFilterForm.appendChild(newlyAddedTagsInput);
    }

    tagContainer.classList.add("filter-selected");


    // Add hidden input for the tag ID
    let tagInput = document.querySelector(`input[name="tags[]"][value="${tagId}"]`);
    if (!tagInput) {
      tagInput = document.createElement("input");
      tagInput.type = "hidden";
      tagInput.name = "tags[]";
      tagInput.value = tagId;
      contentFilterForm.appendChild(tagInput);
    }
  } else {
    tagContainer.classList.remove("filter-selected");

    // Remove hidden input for the tag ID
    let tagInput = document.querySelector(`input[name="tags[]"][value="${tagId}"]`);
    if (tagInput) {
      tagInput.remove();
    }
  }

  toggleCategory(categoryId);
  setCategoryFullySelectedState(categoryId)
}

window.selectAllTriggers = function (categoryId) {
  event.preventDefault();

  categoryTriggers = document.querySelector(`#category-${categoryId}-triggers`);
  isTriggerNotTag = categoryTriggers.querySelector("input[type='checkbox']").id.includes("trigger");

  categoryTriggers.querySelectorAll("input[type='checkbox']").forEach((trigger) => {
    trigger.checked = true;
  });

  if (isTriggerNotTag) {
    categoryTriggers.querySelectorAll("input[type='checkbox']").forEach((trigger) => {
      onToggleTrigger(categoryId, trigger.id.split("-")[1], true);
    });
  } else {
    categoryTriggers.querySelectorAll("input[type='checkbox']").forEach((tag) => {
      onToggleTag(categoryId, tag.id.split("-")[1], true);
    });
  }
}

window.clearAllTriggers = function (categoryId) {
  event.preventDefault();

  categoryTriggers = document.querySelector(`#category-${categoryId}-triggers`);
  isTriggerNotTag = categoryTriggers.querySelector("input[type='checkbox']").id.includes("trigger");

  categoryTriggers.querySelectorAll("input[type='checkbox']").forEach((trigger) => {
    trigger.checked = false;
    triggerIntensitiesContainer = document.querySelector(
      `#trigger-${trigger.id.split("-")[1]}-intensities-container`
    );
    if (triggerIntensitiesContainer) {
      triggerIntensitiesContainer.classList.add("hidden");
    }
  });

  if (isTriggerNotTag) {
    categoryTriggers.querySelectorAll("input[type='checkbox']").forEach((trigger) => {
      onToggleTrigger(categoryId, trigger.id.split("-")[1]);
    });
  } else {
    categoryTriggers.querySelectorAll("input[type='checkbox']").forEach((tag) => {
      onToggleTag(categoryId, tag.id.split("-")[1]);
    });
  }
}

window.onToggleTrigger = function (categoryId, triggerId, selectAll = false) {
  const triggerContainer = document.querySelector(`#trigger-${triggerId}-container`);
  const triggerToggle = document.querySelector(`#trigger-${triggerId}-toggle`);
  const triggerIntensitiesContainer = document.querySelector(`#trigger-${triggerId}-intensities-container`);
  const contentFilterForm = document.querySelector("#content-filter-form");

  if (triggerToggle.checked) {
    // add hidden input for the newly selected individual triggers selected normally and not with "select all"
    let newlyAddedTriggersInput = document.querySelector(`input[name="newly_added_triggers[]"][value="${triggerId}"]`);
    if (!newlyAddedTriggersInput && !selectAll) {
        newlyAddedTriggersInput = document.createElement("input");
        newlyAddedTriggersInput.type = "hidden";
        newlyAddedTriggersInput.name = "newly_added_triggers[]";
        newlyAddedTriggersInput.value = triggerId;
        contentFilterForm.appendChild(newlyAddedTriggersInput);
    }

    triggerContainer.classList.add("filter-selected");

    // Add hidden input for the trigger ID
    let triggerInput = document.querySelector(`input[name="triggers[]"][value="${triggerId}"]`);
    if (!triggerInput) {
        triggerInput = document.createElement("input");
        triggerInput.type = "hidden";
        triggerInput.name = "triggers[]";
        triggerInput.value = triggerId;
        contentFilterForm.appendChild(triggerInput);
    }
  } else {
      triggerContainer.classList.remove("filter-selected");

      // Remove hidden input for the trigger ID
      let triggerInput = document.querySelector(`input[name="triggers[]"][value="${triggerId}"]`);
      if (triggerInput) {
          triggerInput.remove();
      }

      let newlyAddedTriggersInput = document.querySelector(`input[name="newly_added_triggers[]"][value="${triggerId}"]`);
      if (newlyAddedTriggersInput) {
          newlyAddedTriggersInput.remove();
      }

      // Remove hidden input indicating "select all" was used
      let selectAllInput = document.querySelector(`input[name="select_all_triggers[]"][value="${triggerId}"]`);
      if (selectAllInput) {
          selectAllInput.remove();
      }
  }

  toggleCategory(categoryId);
  setCategoryFullySelectedState(categoryId)
}
// ---  Internal functions  --- //

function abortContentFilterRequest() {
  // Abort the in-flight search on the exact node that issued it. htmx stores the
  // xhr on that node (remembered at htmx:beforeRequest), which can differ from a
  // fresh querySelector once a swap has replaced the form, so prefer the
  // remembered node and fall back to the current form.
  const element = window.contentFilterRequestElement || document.querySelector("#content-filter-form");
  if (element) {
    htmx.trigger(element, "htmx:abort");
  }
}

function getContentFilterFormState() {
  // Serialise the form into a stable, order-independent string so two snapshots
  // can be compared to detect whether any filter values have changed.
  const form = document.querySelector("#content-filter-form");
  if (!form) {
    return "";
  }

  const params = new URLSearchParams(new FormData(form));
  params.sort();
  return params.toString();
}

function setResultsBlur(visible = false) {
  // Blur the results while htmx requests are in-flight so it is clear the
  // displayed results are being refreshed.
  const resultsArea = document.querySelector("#video-content-container");
  if (resultsArea) {
    resultsArea.classList.toggle("blur-sm", visible);
  }
}

function isCategoryFullySelected(categoryId) {
  // This also covers tags, as they use the same IDs as triggers
  return document
    .querySelector(`#category-${categoryId}-triggers`)
    .querySelectorAll("input[type='checkbox']:not(:checked)").length == 0;
}

function toggleCategory(categoryId) {
  categoryHasSelectedTriggers =
    document
      .querySelector(`#category-${categoryId}-triggers`)
      .querySelectorAll("input[type='checkbox']:checked").length > 0;


  categoryButton = document.querySelector(`#category-${categoryId}-button`);
  categoryIcon = categoryButton.querySelector(`#category-${categoryId}-icon`);
  if (categoryHasSelectedTriggers) {
    categoryButton.classList.add("control--filter--selected");
    categoryIcon.src = categoryIcon.dataset.selectedIconUrl;
    categoryButton.querySelectorAll("svg path").forEach((path) => path.style.fill = "#FFFFFF");
  } else {
    categoryButton.classList.remove("control--filter--selected");
    categoryButton.querySelectorAll("svg path").forEach((path) => path.style.fill = "#5B404E");
    categoryIcon.src = categoryIcon.dataset.iconUrl;
  }
}

// ensure pagination is done via htmx so that filtering etc works correctly
function addPaginationClickListeners() {
  document.querySelectorAll(".clinic-pagination a").forEach(el => {
    el.addEventListener("click", e => {
      document.querySelector("input[name='page']").value = el.dataset.page;
      htmx.trigger(document.querySelector("#content-filter-form"), "submit");
      e.preventDefault();
    });
  });
}

function setFormState() {
  // Set checked state for checkboxes indicating which categories have all triggers selected
  document.querySelectorAll(".fully-selected-category").forEach(el => {
    const categoryId = el.value
    setCategoryFullySelectedState(categoryId)
  });
}

function setCategoryFullySelectedState(categoryId) {
  const categoryCheckbox = document.querySelector(`#fully-selected-category--${categoryId}`)
  if (isCategoryFullySelected(categoryId)) {
    categoryCheckbox.checked = true;
  } else {
    categoryCheckbox.checked = false;
  }
}

function setToast(path) {
  let newToast;
  if (path.includes("/add")) {
    newToast = document.getElementById("environment-added-toast");
  } else if (path.includes("/remove")) {
    newToast = document.getElementById("environment-removed-toast");
  }

  if (!newToast) {
    return;
  }

  // Immediately hide any visible toasts
  document.querySelectorAll(".toast").forEach(el => {
    el.classList.add("toast--hidden");
  });

  // Set the new toast to fade in, then out again, then hide it
  newToast.classList.remove("toast--hidden");
  setTimeout(function () {
    newToast.classList.add("toast--shown");
  }, 100);
  setTimeout(function () {
    newToast.classList.remove("toast--shown");
    setTimeout(function () {
      newToast.classList.add("toast--hidden");
    }, 1000);
  }, 4500);
}

function storeCountElementState() {
  const countElement = document.getElementById('library-filtered-result-count');
  if (countElement) {
    window.prevElementCount = countElement.textContent
  }
}
const setCountElementClass = function () {
  const countElement = document.getElementById('library-filtered-result-count');
  if (countElement && countElement.textContent != window.prevElementCount) {
    countElement.classList.add('combined-flash-effect');
    // Remove the class after animation ends to reapply it in future mutations
    setTimeout(() => {
      countElement.classList.remove('combined-flash-effect');
    }, 1000); // Adjust the timeout to match the animation duration
  }
}

function getHierarchyItemKeys() {
  // Capture a stable snapshot of the current hierarchy contents and order.
  return Array.from(document.querySelectorAll("#hierarchy-container .sortable-item"))
    .map((item) => item.dataset.hierarchyItemKey)
    .filter(Boolean);
}

function arraysMatch(left, right) {
  return left.length === right.length && left.every((value, index) => value === right[index]);
}

function syncSaveAndReviewState() {
  const button = document.getElementById("save-and-review-button");
  const tooltipAnchor = document.getElementById("save-and-review-tooltip-anchor");

  if (!button || !tooltipAnchor) {
    return;
  }

  const initialKeys = JSON.parse(button.dataset.initialHierarchyKeys || "[]");
  const hasChanges = !arraysMatch(initialKeys, getHierarchyItemKeys());

  // Keep the CTA disabled until the hierarchy differs from its initial page-load state.
  button.disabled = !hasChanges;
  button.setAttribute("aria-disabled", String(!hasChanges));
  tooltipAnchor.classList.toggle("is-disabled", !hasChanges);
}

function initializeSaveAndReviewButton() {
  const button = document.getElementById("save-and-review-button");

  if (!button || button.dataset.initialized === "true") {
    return;
  }

  // Store the original hierarchy once, then compare future HTMX updates against it.
  button.dataset.initialHierarchyKeys = JSON.stringify(getHierarchyItemKeys());
  button.dataset.initialized = "true";
  button.addEventListener("click", function () {
    window.location.href = button.dataset.href;
  });

  syncSaveAndReviewState();
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById('video_library_controls')) {
    setFormState();
    addPaginationClickListeners();
    initializeSaveAndReviewButton();

    // The page loads with the current form values already applied to the
    // results, so seed the "applied" state from them. It is updated whenever a
    // search settles so closeTriggerModals can tell when the form has drifted
    // from what is loaded (e.g. after an aborted request) and re-issue.
    window.contentFilterAppliedState = getContentFilterFormState();

    document.body.addEventListener('htmx:beforeRequest', function(event) {
      storeCountElementState();
      setResultsBlur(!!event.srcElement.getAttribute("hx-indicator")); // only blur if the form making the request has a loading indicator

      // Remember the exact element that issued the search request. htmx stores
      // the in-flight xhr on this specific node (event.detail.elt), and that
      // node can be replaced in the DOM by a later swap, so a fresh
      // querySelector may return a different element that has no xhr to abort.
      if (event.detail.elt.id === "content-filter-form") {
        window.contentFilterRequestElement = event.detail.elt;
      }
    });

    document.body.addEventListener('htmx:afterRequest', function(event) {
      setResultsBlur();

      if (event.detail.elt === window.contentFilterRequestElement) {
        window.contentFilterRequestElement = null;
      }

      setToast(event.detail.pathInfo.finalRequestPath)
      setFormState();
      addPaginationClickListeners();
    });

    document.body.addEventListener('htmx:afterSettle', function(event) {
      setCountElementClass();
      syncSaveAndReviewState();

      // A search has finished loading, so the form values are now reflected in
      // the displayed results. Record them as the applied state. Aborted
      // requests never settle, so they correctly leave the applied state stale.
      if (event.detail.elt && event.detail.elt.id === "video-content-container") {
        window.contentFilterAppliedState = getContentFilterFormState();
      }
    });
  }
});
